import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});

// Enable Tanstack Query Devtools
window.__TANSTACK_QUERY_CLIENT__ = queryClient;
